/**
 * Component for displaying a consistent loading placeholder that is centered
 * within the parent component
 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';

const propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    progress: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {
  text: null,
  className: null,
};

export function UnstyledLoadingPlaceholder({ text, classes, className }) {
  return (
    <div className={classnames(className, classes.root)}>
      <CircularProgress className={classes.progress} />
      {text && (
        <Typography variant="body2" align="center" className={classes.text}>
          {text}
        </Typography>
      )}
    </div>
  );
}

UnstyledLoadingPlaceholder.propTypes = propTypes;
UnstyledLoadingPlaceholder.defaultProps = defaultProps;

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    width: '100%',
    padding: `${theme.spacing(4)}px 0`,
  },
  progress: {
    margin: '0 auto',
  },
  text: {
    marginTop: theme.spacing(2),
  },
});

export default withStyles(styles)(UnstyledLoadingPlaceholder);
